import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: 1.5rem;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: 1.5rem;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: flex-start;\n\n  /* Size */\n  margin-bottom: 1rem;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import InputLabel from "./InputLabel";
import InputMessage from "./InputMessage";
import { media } from "../../Utils/Constants";
import isArray from "lodash/isArray";

var withInputWrapper = function withInputWrapper(options) {
  return function (Input) {
    var WithInputWrapper = /*#__PURE__*/function (_PureComponent) {
      _inherits(WithInputWrapper, _PureComponent);

      function WithInputWrapper(props) {
        var _this;

        _classCallCheck(this, WithInputWrapper);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WithInputWrapper).call(this, props));
        _this.generatedId = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 6);
        return _this;
      }

      _createClass(WithInputWrapper, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              id = _this$props.id,
              label = _this$props.label,
              message = _this$props.message,
              insetLabel = _this$props.insetLabel,
              dark = _this$props.dark,
              size = _this$props.size,
              noMargin = _this$props.noMargin,
              valid = _this$props.valid,
              error = _this$props.error,
              wrapped = _this$props.wrapped,
              style = _this$props.style,
              inputRef = _this$props.inputRef,
              props = _objectWithoutProperties(_this$props, ["id", "label", "message", "insetLabel", "dark", "size", "noMargin", "valid", "error", "wrapped", "style", "inputRef"]);

          var isWrapped = !!(wrapped || label || message);
          return isWrapped ? React.createElement(StyledInputWrapper, {
            size: size,
            noMargin: noMargin,
            style: style
          }, label && React.createElement(InputLabel, _extends({
            htmlFor: id || this.generatedId,
            inset: options && options.insetLabel && insetLabel
          }, {
            dark: dark,
            size: size,
            valid: valid,
            error: error
          }), label), React.createElement(Input, _extends({
            inputRef: inputRef,
            id: id || this.generatedId
          }, props, {
            dark: dark,
            size: size,
            valid: valid,
            error: error
          })), message && React.createElement(InputMessage, {
            dark: dark,
            size: size,
            valid: valid,
            error: error
          }, isArray(message) ? message[0] : message)) : React.createElement(Input, _extends({
            inputRef: inputRef,
            id: id || this.generatedId
          }, props, {
            dark: dark,
            size: size,
            valid: valid,
            error: error,
            style: style
          }));
        }
      }]);

      return WithInputWrapper;
    }(PureComponent);

    WithInputWrapper.displayName = "withInputWrapper(".concat(Input.displayName || "Component", ")");
    return WithInputWrapper;
  };
};

export default withInputWrapper;
var StyledInputWrapper = styled.div(_templateObject(), media.greaterThan("tablet")(_templateObject2(), function (props) {
  return props.size === "l" && css(_templateObject3());
}, function (props) {
  return props.size === "xl" && css(_templateObject4());
}), function (props) {
  return props.noMargin && "margin-bottom: 0;";
});